import styled from 'styled-components'

export const Wrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  flex: 1;

  h1 {
    margin-top: 10%;
  }

  p + p {
    margin-top: 24px;
  }
`

export const Content = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
`
